import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { X, ChevronLeft, ChevronRight, Download, Heart, Share2, Play } from 'lucide-react'

// Type definition for gallery media items
interface GalleryMedia {
  id: number
  src: string
  alt: string
  category: string
  title: string
  description: string
  type: 'image' | 'video'
  thumbnail?: string
}

// Gallery media items - supporting both images and videos
const galleryMedia: GalleryMedia[] = [
  {
    id: 1,
    src: '/images/gallery/main-gallery/candid.jpeg',
    alt: 'Candid Photo',
    category: 'Classes',
    title: 'Candid Photo',
    description: 'Candid Photo',
    type: 'image' as const
  },
  // {
  //   id: 2,
  //   src: '/images/gallery/main-gallery/project-vikas-video-intro.mp4',
  //   alt: 'Bollywood Dance Class',
  //   category: 'Classes',
  //   title: 'Bollywood Dance Class',
  //   description: 'High-energy Bollywood dance session with our enthusiastic students',
  //   type: 'video',
  //   thumbnail: '/images/gallery/main-gallery/candid.jpeg'
  // },
  // {
  //   id: 13,
  //   src: '/videos/dance-performance-1.mp4',
  //   alt: 'Dance Performance Video',
  //   category: 'Events',
  //   title: 'Annual Dance Recital 2024',
  //   description: 'Highlights from our spectacular annual dance recital featuring all dance styles',
  //   type: 'video',
  //   thumbnail: 'https://images.unsplash.com/photo-1594736797933-d0d2d37ecd86?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600'
  // },
  // {
  //   id: 14,
  //   src: '/videos/class-highlights.mp4',
  //   alt: 'Class Highlights Video',
  //   category: 'Classes',
  //   title: 'Behind the Scenes - Dance Classes',
  //   description: 'A glimpse into our daily dance classes and student progress',
  //   type: 'video',
  //   thumbnail: 'https://images.unsplash.com/photo-1504609813442-a8924e83f76e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600'
  // },
  {
    id: 3,
    src: '/images/gallery/main-gallery/project-vikas.jpeg',
    alt: 'Project vikas',
    category: 'Classes',
    title: 'Project vikas',
    description: 'Project vikas volunterring and dance class',
    type: 'image' as const
  },
  {
    id: 4,
    src: '/images/gallery/main-gallery/specialchildren1.jpeg',
    alt: 'Special children',
    category: 'Classes',
    title: 'Special children',
    description: 'Special children dance class',
    type: 'image' as const
  },
  {
    id: 5,
    src: '/images/gallery/main-gallery/specialchildren2.jpeg',
    alt: 'Special children',
    category: 'Workshops',
    title: 'Special children',
    description: 'Special children dance class',
    type: 'image' as const
  },
  {
    id: 6,
    src: '/images/gallery/main-gallery/womandance1.jpeg',
    alt: 'Woman dance',
    category: 'Classes',
    title: 'Woman dance',
    description: 'Woman dance class',
    type: 'image' as const
  },
  // {
  //   id: 7,
  //   src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600',
  //   alt: 'Studio Interior',
  //   category: 'Studio',
  //   title: 'Our Beautiful Studio',
  //   description: 'Spacious and well-equipped dance studio with professional flooring',
  //   type: 'image'
  // },
  // {
  //   id: 8,
  //   src: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600',
  //   alt: 'Group Performance',
  //   category: 'Events',
  //   title: 'Group Performance',
  //   description: 'Students showcasing their skills in a group performance',
  //   type: 'image'
  // },
  // {
  //   id: 9,
  //   src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600',
  //   alt: 'Dance Competition',
  //   category: 'Events',
  //   title: 'Dance Competition',
  //   description: 'Our students participating in regional dance competitions',
  //   type: 'image'
  // },
  // {
  //   id: 10,
  //   src: 'https://images.unsplash.com/photo-1594736797933-d0d2d37ecd86?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600',
  //   alt: 'Award Ceremony',
  //   category: 'Awards',
  //   title: 'Award Ceremony',
  //   description: 'Celebrating our students\' achievements and progress',
  //   type: 'image'
  // },
  // {
  //   id: 11,
  //   src: 'https://images.unsplash.com/photo-1504609813442-a8924e83f76e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600',
  //   alt: 'Cultural Festival',
  //   category: 'Events',
  //   title: 'Cultural Festival',
  //   description: 'Students performing at local cultural festivals',
  //   type: 'image'
  // },
  {
    id: 12,
    src: '/images/gallery/main-gallery/project-vikas2.jpeg',
    alt: 'Dance Workshop',
    category: 'Workshops',
    title: 'Dance Workshop',
    description: 'Special workshops with guest instructors and master classes',
    type: 'image' as const
  }
]

const categories = ['All', 'Classes', 'Events', 'Studio', 'Awards', 'Workshops']

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('All')
  const [selectedMedia, setSelectedMedia] = useState<GalleryMedia | null>(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const filteredMedia = selectedCategory === 'All' 
    ? galleryMedia 
    : galleryMedia.filter(media => media.category.toLowerCase() === selectedCategory.toLowerCase())

  const openLightbox = (media: GalleryMedia, index: number) => {
    setSelectedMedia(media)
    setCurrentIndex(index)
  }

  const closeLightbox = () => {
    setSelectedMedia(null)
  }

  const nextMedia = () => {
    const nextIndex = (currentIndex + 1) % filteredMedia.length
    setCurrentIndex(nextIndex)
    setSelectedMedia(filteredMedia[nextIndex])
  }

  const prevMedia = () => {
    const prevIndex = currentIndex === 0 ? filteredMedia.length - 1 : currentIndex - 1
    setCurrentIndex(prevIndex)
    setSelectedMedia(filteredMedia[prevIndex])
  }


  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero Section */}
      <section className="gradient-bg text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Our <span className="text-yellow-300">Gallery</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Step into our world of dance through these beautiful moments captured 
              in our studio. From classical performances to modern choreography, 
              see the passion and dedication of our students in photos and videos.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedCategory === category
                    ? 'bg-primary-600 text-white'
                    : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
          >
            {filteredMedia.map((media, index) => (
              <motion.div
                key={media.id}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group cursor-pointer"
                onClick={() => openLightbox(media, index)}
              >
                <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                  {media.type === 'video' ? (
                    <div className="relative">
                      <img
                        src={media.thumbnail || media.src}
                        alt={media.alt}
                        className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                      {/* Video Play Button Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/40 transition-colors duration-300">
                        <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white transition-colors duration-300">
                          <Play className="w-8 h-8 text-gray-800 ml-1" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <img
                      src={media.src}
                      alt={media.alt}
                      className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  )}
                  
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white text-center">
                      <div className="text-lg font-semibold mb-2">{media.title}</div>
                      <div className="text-sm">{media.description}</div>
                    </div>
                  </div>
                  
                  <div className="absolute top-2 right-2 flex gap-2">
                    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                      media.category === 'Classes' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-400' :
                      media.category === 'Events' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400' :
                      media.category === 'Studio' ? 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400' :
                      media.category === 'Awards' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400' :
                      media.category === 'Workshops' ? 'bg-pink-100 text-pink-800 dark:bg-pink-900/20 dark:text-pink-400' :
                      'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
                    }`}>
                      {media.category}
                    </span>
                    {media.type === 'video' && (
                      <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400">
                        Video
                      </span>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {filteredMedia.length === 0 && (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">📸🎥</div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">No media found</h3>
              <p className="text-gray-600 dark:text-gray-400">
                No images or videos available for the selected category.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedMedia && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={closeLightbox}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="relative max-w-4xl max-h-[90vh] w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={closeLightbox}
                className="absolute top-4 right-4 z-10 p-2 bg-black/50 rounded-full text-white hover:bg-black/70 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>

              {/* Navigation Buttons */}
              {filteredMedia.length > 1 && (
                <>
                  <button
                    onClick={prevMedia}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 p-2 bg-black/50 rounded-full text-white hover:bg-black/70 transition-colors"
                  >
                    <ChevronLeft className="w-6 h-6" />
                  </button>
                  <button
                    onClick={nextMedia}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 p-2 bg-black/50 rounded-full text-white hover:bg-black/70 transition-colors"
                  >
                    <ChevronRight className="w-6 h-6" />
                  </button>
                </>
              )}

              {/* Media Content */}
              {selectedMedia.type === 'video' ? (
                <div className="relative">
                  <video
                    src={selectedMedia.src}
                    className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                    controls
                    preload="metadata"
                    poster={selectedMedia.thumbnail}
                  />
                </div>
              ) : (
                <img
                  src={selectedMedia.src}
                  alt={selectedMedia.alt}
                  className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                />
              )}

              {/* Media Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
                <h3 className="text-xl font-semibold text-white mb-2">{selectedMedia.title}</h3>
                <p className="text-gray-200 mb-4">{selectedMedia.description}</p>
                <div className="flex items-center gap-4">
                  <span className={`px-3 py-1 text-sm font-semibold rounded-full ${
                    selectedMedia.category === 'Classes' ? 'bg-purple-500 text-white' :
                    selectedMedia.category === 'Events' ? 'bg-blue-500 text-white' :
                    selectedMedia.category === 'Studio' ? 'bg-green-500 text-white' :
                    selectedMedia.category === 'Awards' ? 'bg-yellow-500 text-white' :
                    selectedMedia.category === 'Workshops' ? 'bg-pink-500 text-white' :
                    'bg-gray-500 text-white'
                  }`}>
                    {selectedMedia.category}
                  </span>
                  {selectedMedia.type === 'video' && (
                    <span className="px-3 py-1 text-sm font-semibold rounded-full bg-red-500 text-white">
                      Video
                    </span>
                  )}
                  <div className="flex items-center gap-2 text-white">
                    <button className="p-2 hover:bg-white/20 rounded-full transition-colors">
                      <Heart className="w-4 h-4" />
                    </button>
                    <button className="p-2 hover:bg-white/20 rounded-full transition-colors">
                      <Share2 className="w-4 h-4" />
                    </button>
                    <button className="p-2 hover:bg-white/20 rounded-full transition-colors">
                      <Download className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Media Counter */}
              <div className="absolute top-4 left-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
                {currentIndex + 1} / {filteredMedia.length}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
